import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { EngagementUsersResponse } from '../models/client-engagement/engagement-summary/engagementUsersResponse.model';
import { Response } from '../models/common/response.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MemberService {

  private readonly baseURL = `${environment.apiUrl}/Engagement`;

  constructor(private readonly httpClient: HttpClient) {}

  getEngagementUsers(engagementId: number): Observable<Response<EngagementUsersResponse[]>> {
    return this.httpClient.get<Response<EngagementUsersResponse[]>>(this.baseURL+`/${engagementId}/users`);
  }

  getLoginUserDetails(engagementId: number, userId: string): Observable<Response<boolean>> {
      return this.httpClient.get<Response<boolean>>(this.baseURL+`/${engagementId}/IsEngagementMember/${userId}`);
  }
}
